/* eslint-disable import/prefer-default-export */
import { Conversation, GetConversationSignature } from '@centecomm/portal-service';
import { conversationsActions } from '../..';
import { ConversationsActionTypes } from '../../Conversations/actions';
import { StateRecord, Streams } from '../../../Types';
import { ConversationEventTypes, MessageSentToConversation } from '../../../Types/Conversations/Events';
import { MessageSentToConversationWrappedEvent, WrappedConversationEvent } from '../../../Types/Conversations/WrappedEvents';

export const messageSentToConversationHandler = (
    { conversationId, metadata, message, messageId, userId }: Streams.MessageSentToConversationStreamMessage,
    conversations: StateRecord<Conversation>,
    conversationEvents: StateRecord<WrappedConversationEvent[]>,
    currentUserId: number,
    dispatch,
    getConversation: GetConversationSignature,
): void => {
    if (conversations.hasOwnProperty(conversationId)) {
        if (metadata.userId !== currentUserId) {
            dispatch({
                type: conversationsActions.INCREMENT_UNREAD_MESSAGES,
                payload: conversationId,
            } as ConversationsActionTypes);
        }

        if (conversationEvents.hasOwnProperty(conversationId))
            dispatch({
                type: conversationsActions.ADD_EVENT_TO_CONVERSATION,
                payload: {
                    conversationId: conversationId,
                    event: {
                        type: ConversationEventTypes.MessageSentToConversation,
                        event: {
                            metadata: {
                                eventDate: metadata.eventDate,
                                userId: userId,
                            },
                            messageId: messageId,
                            userId: userId,
                            message: message,
                        } as MessageSentToConversation,
                    } as MessageSentToConversationWrappedEvent,
                },
            } as ConversationsActionTypes);
    } else {
        getConversation(conversationId)
            .then((conversation: Conversation) => {
                dispatch({
                    type: conversationsActions.ADD_CONVERSATION,
                    payload: conversation,
                });
            })
            .catch((e) => {
                console.error(e);
            });
    }
};
